var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikeCarousel(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "60px",
    height: "60px",
    viewBox: "0 0 70 70",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikeCarousel") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M19.7897246,22.8553167 C21.5421833,21.0428765 23.8463406,20.135428 26.1536195,20.135428 C28.4608984,20.135428 30.7766501,21.0428802 32.5291459,22.8553167 L34.6310707,25.0358183 L36.7330327,22.8667931 C40.2379873,19.2418428 45.9675002,19.2419236 49.4724176,22.8667931 C52.9773722,26.4916662 52.9773722,32.3134456 49.4724176,35.9383224 C44.7026366,40.8713423 39.9350102,45.8098707 35.1652663,50.7427804 C35.0248716,50.8894554 34.829576,50.9725573 34.6252736,50.9725573 C34.4209711,50.9725573 34.2256755,50.8894554 34.0852808,50.7427804 L19.7897246,35.9268278 C16.2887835,32.2991452 16.2847701,26.4801311 19.7897246,22.8553167 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Members-Grid-OFF-Copy-2",
    transform: "translate(-181.000000, -1179.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLikeCarousel",
    transform: "translate(181.000000, 1179.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M35,0 C15.7491876,0 0,15.7491876 0,35 C0,54.2508124 15.7491876,70 35,70 C54.2508124,70 70,54.2508124 70,35 C70,15.7491876 54.2508124,0 35,0 Z M35,0.985915493 C53.7063063,0.985915493 69.0140845,16.2936937 69.0140845,35 C69.0140845,53.7063063 53.7063063,69.0140845 35,69.0140845 C16.2936937,69.0140845 0.985915493,53.7063063 0.985915493,35 C0.985915493,16.2936937 16.2936937,0.985915493 35,0.985915493 Z",
    id: "Stroke-1-Copy",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask-Copy-3",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikeCarousel);
export default __webpack_public_path__ + "static/media/icLikeCarousel.f52150d1cd2f90fc73a530d149cb5f7c.svg";
export { ForwardRef as ReactComponent };